export default __webpack_public_path__ + "static/media/resume-2.2abe3f13.png";